import { RxJsonSchema } from 'rxdb';

export interface UserSettingDoc {
	userId: string;
	currentShopId: number;
	updatedAt: number;
}

export const USER_SETTINGS_SCHEMA: RxJsonSchema<UserSettingDoc> = {
	title: 'User settings schema',
	version: 0,
	primaryKey: 'userId',
	type: 'object',
	properties: {
		userId: {
			type: 'string',
			maxLength: 100
		},
		currentShopId: {
			type: 'number'
		},
		updatedAt: {
			type: 'number'
		}
	},
	required: ['userId', 'currentShopId']
};
